module.exports = __webpack_public_path__ + "img/gl4.204310b4.jpg";